import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

import { computed, Ref, PropType, inject } from 'vue';

import { useGetAttributeQuery } from '@/entities/attribute/hooks';

import { Attribute, GetAttributeData } from '@/entities/attribute/types';
import { DeviceCreateFormProvider, DeviceModelFormFieldType } from '@/entities/device/types';

import { NkFormItem, NkInputText, NkCheckbox, NkInputNumber, NkDatePicker } from '@/core/components';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceModelFormPartField',
  props: {
  model: {
    type: Object as PropType<DeviceModelFormFieldType>,
    required: true,
  },
  fieldPath: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props



const deviceForm: DeviceCreateFormProvider = inject('deviceForm', undefined);

const attributeData: Ref<GetAttributeData> = computed(() => ({
  id: (props.model.attributeId as Attribute['id']),
}));

const { data: attribute } = useGetAttributeQuery(attributeData, {
  onSuccess: (attr) => {
    if (deviceForm && deviceForm?.setAttribute) {
      deviceForm.setAttribute(attr);
    }
  }
});

const attributeType = computed(() => attribute.value?.attributType);

const inputProps = computed(() => ({
  modelValue: props.model?.value,
  'onUpdate:modelValue': (value: DeviceModelFormFieldType['value']) => {
    // eslint-disable-next-line vue/no-mutating-props
    props.model.value = value;
  },
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NkFormItem), {
    prop: `${props.fieldPath}.value`,
    label: _unref(attribute)?.name
  }, {
    default: _withCtx(() => [
      (_unref(attributeType) === 'string' )
        ? (_openBlock(), _createBlock(_unref(NkInputText), _normalizeProps(_mergeProps({ key: 0 }, _unref(inputProps))), null, 16))
        : (_unref(attributeType) === 'int')
          ? (_openBlock(), _createBlock(_unref(NkInputNumber), _mergeProps({ key: 1 }, _unref(inputProps), { min: 0 }), null, 16))
          : (_unref(attributeType) === 'float')
            ? (_openBlock(), _createBlock(_unref(NkInputNumber), _mergeProps({ key: 2 }, _unref(inputProps), {
                float: "",
                min: .5,
                step: .5
              }), null, 16))
            : (_unref(attributeType) === 'datetime')
              ? (_openBlock(), _createBlock(_unref(NkDatePicker), _normalizeProps(_mergeProps({ key: 3 }, _unref(inputProps))), null, 16))
              : (_unref(attributeType) === 'boolean')
                ? (_openBlock(), _createBlock(_unref(NkCheckbox), _normalizeProps(_mergeProps({ key: 4 }, _unref(inputProps))), {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(attribute)?.name), 1)
                    ]),
                    _: 1
                  }, 16))
                : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["prop", "label"]))
}
}

})